/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Dashboard from "../Dashboard/Dashboard";

type Props = {
  text: string;
  icon: any;
};

export default function PageNotFound(props: Props) {
  return (
    <Dashboard>
      <div
        style={{ alignItems: "center" }}
      >
        <div style={{ textAlign: "center" }}>
          {props.icon}
          <h2>{props.text}</h2>
        </div>
      </div>
    </Dashboard>
  );
}
